import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { CommissionTier } from 'src/app/recruiting/locums-margin-calculator/models/commission-tier.model';
import { MalpracticeInsuranceRate } from 'src/app/recruiting/locums-margin-calculator/models/malpractice-insurance-rate.model';
import { combine } from 'src/app/shared/utilities/route';
import { TargetMargin } from '../models/target-margin.model';

@Injectable({ providedIn: 'root' })
export class MarginCalculationsService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getContractFee(facilityId: number): Observable<number> {
        return this.http.get<number>(
            `${this.coreApiPath}/locums/margin-calculations/contract-fees?facilityId=${facilityId}`
        );
    }

    getMalpracticeInsuranceRates(): Observable<MalpracticeInsuranceRate[]> {
        return this.http.get<MalpracticeInsuranceRate[]>(
            `${this.coreApiPath}/locums/margin-calculations/malpractice-insurance-rates`
        );
    }

    getTargetMargins(): Observable<TargetMargin[]> {
        return this.http.get<TargetMargin[]>(`${this.coreApiPath}/locums/margin-calculations/target-margins`);
    }

    getCommissionTiers(): Observable<CommissionTier[]> {
        return this.http.get<CommissionTier[]>(`${this.coreApiPath}/locums/margin-calculations/commission-tiers`);
    }
}
